import React from "react";

import HomeUI from "../../ui/homeUI/_index";

const PlanSenderPage = () => {
  return (
    <HomeUI />
  )
}

export default PlanSenderPage;
